import { FilterModel } from './filter.model';
import { FilterType } from './filter.type';
import { YES_NO_FILTER_OPTIONS } from './yes-no-filter-options';

const toSelectOptions = (values: string[]) =>
  values.map((value) => ({ label: value, value }));

export const PHYSICAL_PRODUCT_LIST_FILTERS: FilterModel[] = [
  {
    fieldName: 'is_active',
    label: 'physicalProducts.fields.isActive',
    type: FilterType.radio,
    options: YES_NO_FILTER_OPTIONS,
    value: '',
  },
  {
    fieldName: 'platform',
    label: 'physicalProducts.fields.platform',
    type: FilterType.select,
    options: toSelectOptions(['web', 'mobile']),
    value: '',
  },
  {
    fieldName: 'type',
    label: 'physicalProducts.fields.type',
    type: FilterType.select,
    options: toSelectOptions(['one_time', 'recurring']),
    value: '',
  },
  {
    fieldName: 'country',
    label: 'physicalProducts.fields.countries',
    type: FilterType.select,
    options: [
      {
        label: 'shippingRates.dialogs.countryOptions.usa',
        value: 'US',
        translate: true,
      },
      {
        label: 'shippingRates.dialogs.countryOptions.canada',
        value: 'CA',
        translate: true,
      },
    ],
    value: '',
  },
];
